import { parse } from 'hub-http/helpers/params';
import PortalIdParser from 'PortalIdParser';
import { generatePath } from 'react-router-dom';
import { ORGANIZE_ROUTE, TEMPLATE_EDITOR_ROUTE, EDIT_ARTICLE_ROUTE, INSIGHTS_ARTICLE_ROUTE } from '../constants/RouteConstants';
const getBaseAppUrl = rootSlug => {
  const portalId = PortalIdParser.get();
  return `//${window.location.hostname}/${rootSlug}/${portalId}`;
};
export const getEditorUrl = articleId => `${getBaseAppUrl('knowledge-article')}/editor/${articleId}/content?redirectUrl=${window.location.pathname}`;
export const getRootUrl = () => `/knowledge/${PortalIdParser.get()}`;
export const getEmbeddedOnboardingRootUrl = () => `/knowledge-onboarding-embed/${PortalIdParser.get()}`;
export const getThemeSettingsEditorUrl = (themeSettingsId, themeTitle, language, additionalLanguages = []) => {
  return `${getBaseAppUrl('theme-editor')}/edit/@hubspot/cms-knowledge-base-theme?themeVariant=${themeSettingsId}&themeTitle=${themeTitle}&fromAppName=knowledgeBase&redirectUrl=${window.location.pathname}&previewLanguage=${language}&translations=${additionalLanguages.concat(language)}`;
};
export const getThemeSettingsEditorUrlWithKBRedirectUrl = (themeTitle, knowledgeBaseId, language, additionalLanguages = []) => {
  return `${getBaseAppUrl('theme-editor')}/edit/@hubspot/cms-knowledge-base-theme?themeVariant=${knowledgeBaseId}&themeTitle=${themeTitle}&fromAppName=knowledgeBase&redirectUrl=${getRootUrl()}/${knowledgeBaseId}&previewLanguage=${language}&translations=${additionalLanguages.concat(language)}`;
};
export const getGlobalContentEditorUrl = (themeSettingsId, partialName) => {
  return `${getBaseAppUrl('global-content')}/editor/?assetPath=@hubspot/cms-knowledge-base-theme/templates/partials/${partialName === 'header' ? 'knowledgebase-header.html' : 'knowledgebase-footer.html'}&themeVariant=${themeSettingsId}&fromAppName=knowledgeBase&redirectUrl=${window.location.pathname}&templatePath=@hubspot/cms-knowledge-base-theme/templates/knowledgebase-home.html`;
};
export const getArticlePerformanceUrl = articleId => `${getRootUrl()}${generatePath(INSIGHTS_ARTICLE_ROUTE, {
  articleId
})}`;
export const getCustomizeTemplateUrl = knowledgeBaseId => `${getRootUrl()}${generatePath(TEMPLATE_EDITOR_ROUTE, {
  knowledgeBaseId
})}`;
export const getEditArticleUrl = articleId => `${getRootUrl()}${generatePath(EDIT_ARTICLE_ROUTE, {
  articleId
})}`;
export const getListsUrl = () => `/lists/${PortalIdParser.get()}`;
export const getOrganizeUrl = knowledgeBaseId => `${getRootUrl()}${generatePath(ORGANIZE_ROUTE, {
  knowledgeBaseId
})}`;
export function getKnowledgeBaseUrl(domain, rootSlug, includePrimaryLanguageInSlug, language) {
  const langSlug = includePrimaryLanguageInSlug ? `/${language}` : '';
  return `https://${domain}${langSlug}${rootSlug ? `/${rootSlug}` : ''}`;
}
export function getKnowledgeBaseSearchTermUrl(absoluteUrl, searchTerm) {
  return `${absoluteUrl}/kb-search-results?term=${encodeURIComponent(searchTerm)}`;
}
export function getSettingUrl(tab, knowledgeBaseId) {
  const baseUrl = knowledgeBaseId ? `${getBaseAppUrl('service-hub-settings')}/${knowledgeBaseId}` : `${getBaseAppUrl('service-hub-settings')}`;
  return tab ? `${baseUrl}/${tab}` : `${baseUrl}/knowledge`;
}
export function getUpgradeUrl() {
  return `${getBaseAppUrl('upgrade')}/knowledge-base`;
}
export function getInboxSettingsUrl(inboxId) {
  return `${getBaseAppUrl('live-messages-settings')}/inboxes${inboxId ? `/edit/${inboxId}/forms` : ''}`;
}
// utils
export const getQueryParams = () => parse(window.location.search.slice(1));
export function getImportWizardUrl(csvImport) {
  const portalId = PortalIdParser.get();
  if (csvImport) {
    return `/site-importer/${portalId}/content-import/wizard/new/KNOWLEDGE_BASE/csv`;
  }
  return `/site-importer/${portalId}/content-import/wizard/import-type/KNOWLEDGE_BASE`;
}
export const getDomainSettingsPath = () => `/settings/${PortalIdParser.get()}/domains`;